export default __webpack_public_path__ + "static/media/news-10.7faa6e07.jpg";